import React from 'react';
import { differenceWith, intersectionWith, isEqual } from 'lodash';

import { connect } from 'react-redux';
import { Brand } from '../../../common/models/FilterSettings';
import { BrandsFilterPanel } from './BrandsFilterPanel';
import Store from '../../../common/models/Store';

interface BrandsFilterProps {
  availableBrands: Brand[];
  handleFilterClick: (brandsIds: string[]) => void;
  selectedBrandsIds: string[];
}

const mapStateToProps = ({ api: { s3BasePath } }: Store) => ({ s3BasePath });

const updateSelection = (
  selectedBrandId: string,
  selectedBrandsIds: string[],
  handleFilterClick: (brandsIds: string[]) => void,
) => {
  let alreadySelectedBrandsIds = selectedBrandsIds;

  const selected = intersectionWith<string, string>(alreadySelectedBrandsIds, [selectedBrandId], isEqual);
  if (selected.length !== 0) {
    alreadySelectedBrandsIds = differenceWith<string, string>(alreadySelectedBrandsIds, [selectedBrandId], isEqual);
  } else {
    alreadySelectedBrandsIds = alreadySelectedBrandsIds.concat(selectedBrandId);
  }

  handleFilterClick(alreadySelectedBrandsIds.map(e => e.toString()));
};

const BrandsFilter: React.FC<BrandsFilterProps & { s3BasePath: string }> = React.memo(
  ({ availableBrands, handleFilterClick, s3BasePath, selectedBrandsIds }) => {
    const selectedBrandsIdsSet = new Set<string>(selectedBrandsIds);

    return (
      <BrandsFilterPanel
        brands={availableBrands.map(brand => ({
          ...brand,
          selected: selectedBrandsIdsSet.has(brand.id),
        }))}
        onItemClicked={({ id: selectedBrandId }) => {
          updateSelection(selectedBrandId, selectedBrandsIds, handleFilterClick);
        }}
        s3BasePath={s3BasePath}
      />
    );
  },
);

export default connect(mapStateToProps)(BrandsFilter);
